module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "id": "app"
    }
  }, [(_vm.isRouterAlive) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2df71946"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 679
// module chunks = 85